
/* eslint-disable */
// disable because of thse warnings:
// Line 153:32:  eval can be harmful               no-eval
//   Line 157:31:  eval can be harmful               no-eval
//   Line 170:34:  Unnecessary escape character: \d  no-useless-escape 
//   Line 170:37:  Unnecessary escape character: \.  no-useless-escape 
//   Line 170:40:  Unnecessary escape character: \d  no-useless-escape 

import { Box, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState, type JSX } from 'react';
import { CustomCellEditorProps, useGridCellEditor } from "ag-grid-react";
import meMarker from "../../../assets/images/me_small.png";
//import zIndex from '@mui/material/styles/zIndex';

const KEY_BACKSPACE = 'Backspace';
const KEY_DELETE = 'Delete';
// const KEY_F2 = 'F2';
const KEY_ENTER = 'Enter';
const KEY_TAB = 'Tab';

export type INumericCellEditorProps = {
    lowerBound?: number;
    lowerBoundOp?: string;
    upperBound?: number;
    upperBoundOp?: string;
    decimals?: number;
    showCornerIcon?: boolean;
    cornerIconTitle?: string;
    onCornerIconClicked?: () => void;
} & CustomCellEditorProps;

// type NumericCellEditorState = {
//     value: string,
//     highlightAllOnFocus: boolean;
// };

export function NumericCellEditor({
    lowerBound,
    lowerBoundOp,
    upperBound,
    upperBoundOp,
    decimals,
    showCornerIcon,
    cornerIconTitle,
    onCornerIconClicked,
    value,
    eGridCell,
    eventKey,
    data,
    onValueChange
}: INumericCellEditorProps): JSX.Element {

    const theme = useTheme();

    // User Story 54279: Research: 2026 Q4 - Review GAS Report 
    const decimalsRegEx: RegExp | undefined = decimals ? new RegExp(`^[+-]?\\d*\\.?\\d{0,${decimals}}$`) : undefined;

   // const createInitialState = (): NumericCellEditorState => {

    //     let startValue;
    //     let highlightAllOnFocus = false;//true;

    //     if (eventKey === KEY_BACKSPACE || eventKey === KEY_DELETE) {
    //         // if backspace or delete pressed, we clear the cell
    //         startValue = '';

    //     } else if (eventKey && eventKey.match(/[a-z]/i)) {
    //         // if a letter was pressed, we start with the letter
    //         startValue = eventKey;
    //         highlightAllOnFocus = false;
    //     } else {

    //         // otherwise we start with the current value
    //         startValue = value;
    //     if (eventKey === KEY_F2) {
    //             highlightAllOnFocus = false;
    //         }
    //     }

    //     // maybe I should call onValueChange here
    //     return {
    //         //value: startValue,
    //         highlightAllOnFocus
    //     };
    // };

    // const initialState = createInitialState();
    // const [value, setValue] = useState(initialState.value);
    // const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(initialState.highlightAllOnFocus);
    const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(true);
    const refInput = useRef<HTMLInputElement>(null);

    // Takes the place of the old afterGuiAttached
    useEffect(() => {
        eGridCell.style.borderColor = '';
        data.valid = true;

        //setValue(props.value);
        if (refInput.current) {
            refInput?.current.focus();
            refInput?.current.select();
        }
    }, []);

    // focus on the input
    useEffect(() => {

        // get ref from React component
        const eInput = refInput.current;
        eInput?.focus();
        if (highlightAllOnFocus) {
            eInput?.select();

            setHighlightAllOnFocus(false);
        }
        // else {
        //     // when we started editing, we want the carot at the end, not the start.
        //     // comes into play in two scenarios: a) when user hits F2 and b)
        //     // when user hits a printable character, then on IE (and only IE) the carot
        //     // was placed after the first character, thus 'apply' would end up as 'pplea'
        //     const length = eInput?.value ? eInput.value.length : 0;
        //     if (length > 0) {
        //     //    eInput?.setSelectionRange(length, length);
        //     }
        // }
    }, [
        highlightAllOnFocus,
        setHighlightAllOnFocus,
        refInput
    ]);

    /* Utility Methods */
    //const cancelBeforeStart = props.charPress && ('1234567890'.indexOf(props.charPress) < 0);
    const cancelBeforeStart = !!eventKey && ('1234567890'.indexOf(eventKey) < 0);

    const isLeftOrRight = (event: React.KeyboardEvent<HTMLInputElement>) => {
        return ['ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1;
    };

    const getCharCodeFromEvent = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event = event || window.event;
        return event.key;
        //return (typeof event.which === "undefined") ? event.keyCode : event.which;
    };

    const isCharNumeric = (char: string) => {
        return !!/\d/.test(char);
    };

    const isKeyDecimal = (char: string) => {
        return (char === '.' && `${value}`.indexOf('.') === -1);
    };

    const isMinus = (char: string) => {
        return (char === '-' && `${value}`.indexOf('-') === -1);
    };

    const isKeyPressedNumeric = (event: React.KeyboardEvent<HTMLInputElement>) => {
        //const charCode = getCharCodeFromEvent(event);
        //const charStr = event.key ? event.key : String.fromCharCode(charCode);
        const charStr = event.key;
        return isCharNumeric(charStr) || isKeyDecimal(charStr) || isMinus(charStr);
    };

    const deleteOrBackspace = (event: React.KeyboardEvent<HTMLInputElement>) => {
        //return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.key) > -1;
    };

    const finishedEditingPressed = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const charCode = getCharCodeFromEvent(event);
        return charCode === KEY_ENTER || charCode === KEY_TAB;
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (isLeftOrRight(event) || deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }

        if (!finishedEditingPressed(event) && (!isKeyPressedNumeric(event) || !isNumberValid(event))) {
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
    };

    const isNumberValid = (event: React.KeyboardEvent<HTMLInputElement>) => {

        if (!decimals) {
            return true;
        }
        const newChar = event.key;

        let value = refInput.current?.value ?? '';

        const selectionStart = refInput.current?.selectionStart ?? 0;
        const selectionEnd = refInput.current?.selectionEnd ?? 0;

        value = value.substring(0, selectionStart) + newChar + value.substring(selectionEnd);

        return decimalsRegEx?.test(value);
    };

    const validate = useCallback((value: number) => {

        let valid = true;
        if (lowerBound !== undefined && lowerBoundOp) {
            valid = (0, eval)(`${value} ${lowerBoundOp} ${lowerBound}`);
        }

        if (valid && upperBound !== undefined && upperBoundOp) {
            valid = (0, eval)(`${value} ${upperBoundOp} ${upperBound}`);
        }

        return valid;
    }, [
        lowerBound,
        lowerBoundOp,
        upperBound,
        upperBoundOp
    ]);

    const onChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        const value = +event.target.value;
        // setValue(event.target.value);
        onValueChange(event.target.value);

        let valid = true;

        // if (event.target.value.trim() === '.') {
        //     valid = false;
        // } else if (event.target.value.trim() !== '') {
        //     valid = validate(value);
        // }
        if (event.target.value.trim() !== '') {
            valid = validate(value);
        }

        data.valid = valid;

        if (!valid) {
            eGridCell.style.borderColor = theme.palette.error.main;
        } else {
            eGridCell.style.borderColor = '';
        }
    };

    /* ag-grid component Editor Lifecycle methods */
    // useImperativeHandle(ref, () => {
    //     return {
    //         // the final value to send to the grid, on completion of editing
    //         getValue() {
    //             let v = `${value}`;
    //             if (v.endsWith('.')) {
    //                 return v.replace('.', '');
    //             }
    //             return v;
    //         },

    //         afterGuiAttached: () => {
    //             props.eGridCell.style.borderColor = '';
    //             props.data.valid = true;

    //             setValue(props.value);
    //             if (refInput.current) {
    //                 refInput?.current.focus();
    //                 refInput?.current.select();
    //             }
    //         },

    //         // Gets called once before editing starts, to give editor a chance to
    //         // cancel the editing before it even starts.
    //         isCancelBeforeStart() {
    //             return cancelBeforeStart;
    //         },

    //         // Gets called once when editing is finished (eg if enter is pressed).
    //         // If you return true, then the result of the edit will be ignored.
    //         isCancelAfterEnd() {
    //             if (typeof value?.trim === "function" && value.trim() !== '') {
    //                 return !validate(+value);
    //             } else {
    //                 return false;
    //             }
    //         }
    //     };
    // });

    const isCancelBeforeStart = useCallback(() => {
        return cancelBeforeStart;
    }, [
        cancelBeforeStart
    ]);

    const isCancelAfterEnd = useCallback(() => {
        if (typeof value?.trim === "function" && value.trim() !== '') {

            // if the last character is a decimal point, remove it
            let v = `${value}`;
            if (v.endsWith('.')) {
                onValueChange(v.replace('.', ''));
            }

            return !validate(+value);
        } else {
            return false;
        }
    }, [
        value,
        validate
    ]);

    useGridCellEditor({
        isCancelBeforeStart,
        isCancelAfterEnd
    });

    return (

        <Box
            sx={{
                position: 'relative',
                top: '0',
                left: '0',
                /////////////////////////////////////////////
                // SPR - Dense Grid - Remove
                // bottom: '0',
                // right: '0',
                /////////////////////////////////////////////

                /////////////////////////////////////////////
                // SPR - Dense Grid - Add
                height: '100%',
                width: "100%"
                /////////////////////////////////////////////
            }}
        >
            <input ref={refInput}
                className="numeric-input"
                //style={{position: 'absolute', top: '0px', right: '0px', left: '0px', bottom:'0px', cursor: 'pointer' }} 
                type='text'
                data-pattern={`^[+-]?\d*\.?\d{0,${decimals ?? 2}}$`}
                pattern={encodeURIComponent(`^[-+]?\d*\.?\d{0,${decimals ?? 2}}$`)}
                // User Story 51313: Research - Ongoing Virtual Keyboard Issues
                //inputMode={props.decimals ? props.decimals === 0 ? 'numeric' : 'decimal' : 'decimal'}
                inputMode="text"
                value={value}
                //onChange={event => setValue(event.target.value)}
                onChange={onChanged}
                onKeyDown={event => onKeyDown(event)}
            />
            {showCornerIcon &&
                <img src={meMarker}
                    style={{ position: 'absolute', top: 2, right: 2, cursor: 'pointer', zIndex: 20000 }}
                    title={cornerIconTitle ?? ''}
                    alt={cornerIconTitle ?? ''}
                    onMouseDown={() => onCornerIconClicked && onCornerIconClicked()
                    }
                />
            }
        </Box>
    );
}

